import React from 'react';
import { ShimmerElementType } from '@fluentui/react';

import { Shimmer } from '../Shimmer';
import { IShimmerCardProps } from '../Shimmer.Props';
import { ShimmerCard } from '../ShimmerCard';

export const ModalShimmer = (props: Omit<IShimmerCardProps, 'children'>) => {
  return (
    <ShimmerCard {...props} stackProps={{ tokens: { childrenGap: 12, padding: 24 } }}>
      <Shimmer width="60%" fullWidth shimmerElements={[{ type: ShimmerElementType.line, height: 16 }]} />
      <Shimmer width="80%" fullWidth shimmerElements={[{ type: ShimmerElementType.line, height: 20 }]} />
      <Shimmer width="85%" fullWidth shimmerElements={[{ type: ShimmerElementType.line, height: 20 }]} />
      <Shimmer width="65%" fullWidth shimmerElements={[{ type: ShimmerElementType.line, height: 20 }]} />
      <Shimmer width="50%" fullWidth shimmerElements={[{ type: ShimmerElementType.line, height: 16 }]} />
    </ShimmerCard>
  );
};
